/* eslint-disable no-alert */
export default {
  install(Vue) {
    Vue.mixin({
      beforeRouteLeave(to, from, next) {
        if (this.haveSaveablesChanged && !to.meta.isEventUnderEditRedirect) {
          const shouldDiscardChanges = window.confirm('Du har gjort ändringar som inte är sparade. Vill du lämna sidan ändå?');
          next(shouldDiscardChanges);
        } else {
          next();
        }
      },
      computed: {
        haveSaveablesChanged() {
          if (!this.$saveables) {
            return false;
          }

          return Object.entries(this.$saveables).some((pair) => pair[1].hasChanged());
        },
        canValuesBeSaved() {
          return this.saveablesEntryValues
            .some((saveable) => saveable.hasChanged())
            && this.saveablesEntryValues.every((saveable) => saveable.isValid());
        },
        saveablesEntryValues() {
          if (!this.$saveables) {
            return [];
          }

          return Object.entries(this.$saveables).map((pair) => pair[1]);
        },
      },
      created() {
        const vm = this;

        if (this.$options.saveables) {
          const saveablesVm = new Vue({
            data() {
              return {
                saveables: { ...vm.$options.saveables.apply(vm) },
              };
            },
          });

          this.$saveables = saveablesVm.saveables;
        }
      },
      methods: {
        resetSaveables() {
          return new Promise((resolve) => {
            const shouldReset = window.confirm('Vill du återställa alla värden?');

            if (shouldReset) {
              this.saveablesEntryValues.forEach((saveable) => saveable.reset());
            }

            resolve();
          });
        },
        updateSaveables() {
          return new Promise((resolve) => {
            this.saveablesEntryValues.forEach((saveable) => saveable.update());
            resolve();
          });
        },
        removeSaveableByKey(key) {
          delete this.$saveables[key];
          this.$saveables = { ...this.$saveables };
        },
        getChangedSaveables() {
          return new Promise((resolve) => {
            const changedSaveables = Object.entries(this.$saveables)
              .filter((pair) => pair[1].hasChanged());

            resolve(Object.fromEntries(changedSaveables));
          });
        },
        mapChangedSaveables() {
          return new Promise((resolve) => {
            const mappedValues = Object.entries(this.$saveables)
              .map((pair) => ({ key: pair[0], saveable: pair[1] }))
              .map(({ key, saveable }) => {
                const mappedValue = saveable.mapChangedValue();

                if (mappedValue instanceof Object) {
                  return mappedValue;
                }

                return { [key]: mappedValue };
              });

            resolve(Object.assign(...mappedValues));
          });
        },
      },
    });
  },
};
